import React from 'react'
import { FiCheck, FiSearch, FiChevronDown, FiChevronLeft } from 'react-icons/fi';
import NavbarMeganu from '../../../@shared/navigations/megamenu';
import { faqHomepage, questions } from './mock';
import { HeroGradient } from "./heroGradient"

export const JobPage = () => {

    return (
        <React.Fragment>
            <title>Job Landing Page</title>
            <NavbarMeganu />
            <HeroGradient />
            <HomeAccordion />
            <Zigzag />
        </React.Fragment>
    )
}
export default JobPage; 


export const HomeAccordion = () => {

    return (
        <div className='home-accordion'>
            <img src="/assets/images/bg/char.png" alt="" />
            <div className='introduce'>
                <h1 className='title'> 
                    People Also Ask
                </h1>
                <p className='description'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat eum itaque quis! Repellat eaque veniam sit, quos dolor totam exercitationem omnis vero iusto vitae dignissimos blanditiis a? Sit, soluta labore.
                </p>                 
                <Accordions data={faqHomepage} />
                <p className="description">
                    Enim veniam ab ad earum quasi veritatis iure cum assumenda aperiam similique corrupti laudantium, neque distinctio molestias excepturi architecto vitae error perferendis consectetur quisquam doloribus! Ex ipsam reprehenderit tempore aut.
                </p>
            </div>
        </div>
    )
}  

const Zigzag = () => {

    return (
        <div className='zigzag'>
            <div className='left'>
                <div className='information'>
                    <h1 className='title'>Millions of downloads have in this month.</h1>
                    <p className='description'>We use worldwide most talent experts and fastest web servers to provide our services</p>
                    <div className="button">Try for free</div>
                </div>
                <div className='image'>
                    <img src="/assets/images/bg/facetoface.png" alt="" className='img' />
                    <div className="circle yellow"></div>
                </div>
            </div>

            <div className='right'>
                <div className='image'>
                    <img src="/assets/images/bg/phone-mockup.png" alt="" />
                    <BlobSvg color="#FBA4A9" />
                 </div>
                <div className='detail'>
                    <h1 className='title'>Look at our mobile app on marketplaces.</h1>
                    <p className='description'>You can arrive us 24/7 every week. We serving all around the world</p>
                    <div className="button">Try for free</div>
                    <ul>
                        <li><FiCheck className='icon' /><p>Fully Responsive.</p></li>
                        <li><FiCheck className='icon' /><p>Based on Bootstrap Grid</p></li>
                        <li><FiCheck className='icon' /><p>Reusable Components.</p></li>
                    </ul>
                </div>
            </div>

            <div className='center'>
                <h1 className='title'>Take your best decision today</h1>
                <p className='description'>  
                What is love? 'tis not hereafter;
Present mirth hath present laughter;</p>

                <a href="##"><div className="button">Take</div></a>
            </div>
        </div>
    )
}
  
export const BlobSvg = ({color='#FBA4A9'}) => {
    return ( 
      <div className="blob"> 
        <svg width="543" height="707" viewBox="0 0 543 707" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={color} fill-rule="evenodd" clip-rule="evenodd" d="M300.317 4.01512C388.365 -16.3435 484.738 49.8036 529.627 128.238C569.369 197.679 506.875 277.651 502.649 357.549C498.873 428.94 542.463 501.982 506.588 563.82C462.994 638.966 387.086 710.598 300.317 706.317C214.744 702.096 169.199 609.475 113.441 544.424C64.3008 487.094 -8.53715 432.404 1.37218 357.549C10.9936 284.868 109.795 270.349 157.134 214.366C214.068 147.036 214.408 23.8789 300.317 4.01512Z"/>
        </svg>
      </div>
    );
}

    

export const Accordions = ({data=questions}) => {

return(
    <div className='accordions'>
        <ul>
            {data?.map((item,i)=>(
                <Question key={`faq-${i}`} item={item} />
            ))}
        </ul>
    </div>
)
}

const Question = ({item}) => {
    const [open, setOpen] = React.useState(false)
    return (
        <li>
            <div className='question' onClick={()=>setOpen(!open)}>
                <p>{item.title}</p>
                <div> {open ? <FiChevronDown size={19} /> : <FiChevronLeft size={19} />} </div>
            </div>
            {open && <p className="description">{item.description}</p> }
        </li>
    )
}



